import Layout from "../../components/Layout/Layout";
import routing from "../../routes/Routing";

function App() {
  return (
    <Layout>{routing}</Layout>
  );
}

export default App;
